'use client';

import { Box, Flex, Typography } from '@coolblue-development/freddy';
import closeOverlayTrigger from '@coolblue-development/ga4-events/triggers/FilterAndSort/closeOverlayTrigger';
import readPropertyInformationTrigger from '@coolblue-development/ga4-events/triggers/FilterAndSort/readPropertyInformationTrigger';
import { useTranslation } from '@i18n/useTranslation';

import type { Facet as FacetType } from '../../types';
import PropertyExplanationTrigger from '../PropertyExplanationTrigger';
import mapFacetToFilterGroup from './helpers/mapFacetToFilterGroup';

export default function Facet({ facet }: { facet: FacetType }) {
  const { t } = useTranslation('webshop');
  const { displayName, propertyExplanationMetaData, name, facetName } = facet;
  const propertyName = `${name}, ${facetName}, ${propertyExplanationMetaData?.productTypeId}`;

  return (
    <Flex direction='column'>
      <Box component='span'>
        <Typography variant='h3' component='span' mb={0} mr={200}>
          {displayName}
        </Typography>

        {propertyExplanationMetaData && (
          <PropertyExplanationTrigger
            productTypeId={propertyExplanationMetaData.productTypeId}
            propertyId={propertyExplanationMetaData.propertyId}
            displayName={displayName}
            trackingOpenTrigger={readPropertyInformationTrigger({
              property_name: propertyName,
              sub_feature: 'filter_list'
            })}
            trackingCloseTrigger={closeOverlayTrigger({
              sub_feature: 'highlights_overlay'
            })}
          >
            {t('filterPage.propertyExplanationLabel')}
          </PropertyExplanationTrigger>
        )}
      </Box>
      {mapFacetToFilterGroup(facet)}
    </Flex>
  );
}
